/**
 * Rillet ARR by month — GENERATED by ~/exec-dash-data/emit-rillet-ts.js
 * (quick-261104-ia3). Do not hand-edit; re-pull and re-emit monthly.
 *
 * Source: Rillet ARR waterfall, status ACTIVE. Pulled 2026-11-04.
 * Churn and new ARR EXCLUDE one/two-month timing gaps (a customer that drops to
 * $0 and comes back is a renewal-booking gap, not churn). The LATEST month is
 * PROVISIONAL: renewals not yet booked in Rillet read as churn until they are.
 * Rillet is not wired into the sync-worker yet — this constant is the bridge.
 */
export interface RilletMonth {
  month: string;
  arr: number;
  customers: number;
  newArr: number;
  expansionArr: number;
  contractionArr: number;
  churnArr: number;
  churnedLogos: number;
  churned: { name: string; arr: number }[];
  newLogos: string[];
}
export interface RilletRenewal { customer: string; contract: string; endDate: string; value: number; renewed: boolean }
export const RILLET_PULLED_ON = '2026-11-04';
export const RILLET_PROVISIONAL_MONTH = '2026-10';
export const RILLET_MONTHS: RilletMonth[] = [
  {
    "month": "2025-01",
    "arr": 10023755,
    "customers": 105,
    "newArr": 0,
    "expansionArr": 15376,
    "contractionArr": 55790,
    "churnArr": 41940,
    "churnedLogos": 14,
    "churned": [
      {
        "name": "Enable-U / Gemeente Almere Support",
        "arr": 9810
      },
      {
        "name": "Enable-U / Ministry of I&W",
        "arr": 8095
      },
      {
        "name": "Enable-U / Waterschap Rivierenland",
        "arr": 2943
      },
      {
        "name": "Enable-U / Gennep",
        "arr": 2616
      },
      {
        "name": "Enable-U/ Gemeente Venray",
        "arr": 2453
      },
      {
        "name": "Enable-U/ Haarlemmermeer (Circle Software)",
        "arr": 1962
      },
      {
        "name": "Enable-U - Gemeente Westland",
        "arr": 1962
      },
      {
        "name": "Enable-U / Gemeente Delft Support",
        "arr": 1962
      },
      {
        "name": "Enable-U / Gemeente Nieuwegein",
        "arr": 1962
      },
      {
        "name": "Enable-U / Gemeente Zutphen",
        "arr": 1962
      },
      {
        "name": "Enable-U / Gemeente Zeist",
        "arr": 1962
      },
      {
        "name": "Enable-U / IJsselgemeenten",
        "arr": 1962
      },
      {
        "name": "Enable-U / Gemeente Asten",
        "arr": 1308
      },
      {
        "name": "Enable-U / Gemeente Haarlemmermeer",
        "arr": 981
      }
    ],
    "newLogos": []
  },
  {
    "month": "2025-02",
    "arr": 10040028,
    "customers": 105,
    "newArr": 0,
    "expansionArr": 16899,
    "contractionArr": 626,
    "churnArr": 0,
    "churnedLogos": 0,
    "churned": [],
    "newLogos": []
  },
  {
    "month": "2025-03",
    "arr": 9934720,
    "customers": 101,
    "newArr": 161000,
    "expansionArr": 242803,
    "contractionArr": 246939,
    "churnArr": 248984,
    "churnedLogos": 6,
    "churned": [
      {
        "name": "CentralSquare Technologies",
        "arr": 200000
      },
      {
        "name": "Delta Dental of Iowa",
        "arr": 37440
      },
      {
        "name": "Primeur Suiss Sa / GLS",
        "arr": 11544
      },
      {
        "name": "Primeur Suisse Sa / ACEA",
        "arr": 5200
      },
      {
        "name": "Primeur Suiss Sa / SIAE",
        "arr": 4245
      },
      {
        "name": "Primeur Suiesse Sa / Credit Agricole, Italy",
        "arr": 3744
      }
    ],
    "newLogos": [
      "WorkCare, Inc.",
      "Flores & Associates LLC"
    ]
  },
  {
    "month": "2025-04",
    "arr": 9683779,
    "customers": 99,
    "newArr": 0,
    "expansionArr": 2697,
    "contractionArr": 0,
    "churnArr": 252557,
    "churnedLogos": 3,
    "churned": [
      {
        "name": "DNAnexus, Inc",
        "arr": 199242
      },
      {
        "name": "Hackbarth Delivery Service, Inc.",
        "arr": 53315
      },
      {
        "name": "LaserShip, Inc.",
        "arr": 6490
      }
    ],
    "newLogos": [
      "Primeur Suisse Sa / ACEA"
    ]
  },
  {
    "month": "2025-05",
    "arr": 9937706,
    "customers": 102,
    "newArr": 0,
    "expansionArr": 239299,
    "contractionArr": 0,
    "churnArr": 0,
    "churnedLogos": 0,
    "churned": [],
    "newLogos": [
      "LaserShip, Inc.",
      "Primeur Suiss Sa / SIAE",
      "Primeur Suiesse Sa / Credit Agricole, Italy"
    ]
  },
  {
    "month": "2025-06",
    "arr": 10294171,
    "customers": 103,
    "newArr": 275000,
    "expansionArr": 209020,
    "contractionArr": 2554,
    "churnArr": 125000,
    "churnedLogos": 1,
    "churned": [
      {
        "name": "Nuvem",
        "arr": 125000
      }
    ],
    "newLogos": [
      "Boston Scientific Cardiac Diagnostics, Inc.",
      "Audiense, LLC (Buxton)"
    ]
  },
  {
    "month": "2025-07",
    "arr": 10299341,
    "customers": 103,
    "newArr": 0,
    "expansionArr": 30276,
    "contractionArr": 25106,
    "churnArr": 0,
    "churnedLogos": 0,
    "churned": [],
    "newLogos": []
  },
  {
    "month": "2025-08",
    "arr": 10342464,
    "customers": 103,
    "newArr": 0,
    "expansionArr": 62833,
    "contractionArr": 19711,
    "churnArr": 0,
    "churnedLogos": 0,
    "churned": [],
    "newLogos": []
  },
  {
    "month": "2025-09",
    "arr": 10754179,
    "customers": 102,
    "newArr": 30000,
    "expansionArr": 489396,
    "contractionArr": 26263,
    "churnArr": 81418,
    "churnedLogos": 2,
    "churned": [
      {
        "name": "NASDAQ",
        "arr": 51418
      },
      {
        "name": "Sifted",
        "arr": 30000
      }
    ],
    "newLogos": [
      "DoseSpot"
    ]
  },
  {
    "month": "2025-10",
    "arr": 11225917,
    "customers": 103,
    "newArr": 180000,
    "expansionArr": 291738,
    "contractionArr": 0,
    "churnArr": 0,
    "churnedLogos": 0,
    "churned": [],
    "newLogos": [
      "Evernorth"
    ]
  },
  {
    "month": "2025-11",
    "arr": 11236897,
    "customers": 104,
    "newArr": 2157,
    "expansionArr": 8823,
    "contractionArr": 0,
    "churnArr": 0,
    "churnedLogos": 0,
    "churned": [],
    "newLogos": [
      "Enable-U / Gemeente Zeist"
    ]
  },
  {
    "month": "2025-12",
    "arr": 12332367,
    "customers": 106,
    "newArr": 295000,
    "expansionArr": 806960,
    "contractionArr": 0,
    "churnArr": 6490,
    "churnedLogos": 1,
    "churned": [
      {
        "name": "LaserShip, Inc.",
        "arr": 6490
      }
    ],
    "newLogos": [
      "Prudential",
      "Rastelli Foods Group LLC",
      "IAHSS"
    ]
  },
  {
    "month": "2026-01",
    "arr": 11942653,
    "customers": 94,
    "newArr": 0,
    "expansionArr": 30772,
    "contractionArr": 36131,
    "churnArr": 373647,
    "churnedLogos": 12,
    "churned": [
      {
        "name": "Meadowbrook, Inc.",
        "arr": 189600
      },
      {
        "name": "Affinity Gallagher",
        "arr": 129600
      },
      {
        "name": "Enable-U / Gemeente Venlo",
        "arr": 20978
      },
      {
        "name": "Primeur Suisse Sa / CNP Vita",
        "arr": 15142
      },
      {
        "name": "Primeur Suisse Sa / Corner Banca",
        "arr": 10708
      },
      {
        "name": "Primeur Suisse Sa / ACEA",
        "arr": 5408
      },
      {
        "name": "Enable-U / Gemeente Amersfoort",
        "arr": 2504
      },
      {
        "name": "Enable-U Waterschap Vechtstromen",
        "arr": 2504
      },
      {
        "name": "Enable-U / Gemeente Dronten",
        "arr": 1978
      },
      {
        "name": "Enable-U / Gemeente Etten-Leur",
        "arr": 1978
      },
      {
        "name": "Enable-U / Gemeente Krimpenerwaard",
        "arr": 1978
      },
      {
        "name": "Enable-U / Gemeente Heemskerk support",
        "arr": 1978
      }
    ],
    "newLogos": []
  },
  {
    "month": "2026-02",
    "arr": 12007805,
    "customers": 96,
    "newArr": 45000,
    "expansionArr": 9016,
    "contractionArr": 0,
    "churnArr": 0,
    "churnedLogos": 0,
    "churned": [],
    "newLogos": [
      "Maxex",
      "Primeur Suisse Sa / Corner Banca"
    ]
  },
  {
    "month": "2026-03",
    "arr": 12272933,
    "customers": 93,
    "newArr": 135000,
    "expansionArr": 183689,
    "contractionArr": 13018,
    "churnArr": 40542,
    "churnedLogos": 4,
    "churned": [
      {
        "name": "DoseSpot",
        "arr": 30000
      },
      {
        "name": "Primeur Suiss Sa / SIAE",
        "arr": 4245
      },
      {
        "name": "Primeur Suiesse Sa / Credit Agricole, Italy",
        "arr": 3894
      },
      {
        "name": "Enable-U / Waterschap Limburg",
        "arr": 2403
      }
    ],
    "newLogos": [
      "Pacific Life Insurance Company"
    ]
  },
  {
    "month": "2026-04",
    "arr": 12330229,
    "customers": 94,
    "newArr": 50000,
    "expansionArr": 7296,
    "contractionArr": 0,
    "churnArr": 0,
    "churnedLogos": 0,
    "churned": [],
    "newLogos": [
      "Sewell Family of Companies, Inc."
    ]
  },
  {
    "month": "2026-05",
    "arr": 12445158,
    "customers": 95,
    "newArr": 71250,
    "expansionArr": 43679,
    "contractionArr": 0,
    "churnArr": 0,
    "churnedLogos": 0,
    "churned": [],
    "newLogos": [
      "Oswald Companies"
    ]
  },
  {
    "month": "2026-06",
    "arr": 12719276,
    "customers": 96,
    "newArr": 72800,
    "expansionArr": 222708,
    "contractionArr": 21390,
    "churnArr": 0,
    "churnedLogos": 0,
    "churned": [],
    "newLogos": [
      "GuideStone Financial Resources of the Southern Baptist Convention"
    ]
  },
  {
    "month": "2026-07",
    "arr": 12662089,
    "customers": 95,
    "newArr": 0,
    "expansionArr": 640,
    "contractionArr": 0,
    "churnArr": 57827,
    "churnedLogos": 1,
    "churned": [
      {
        "name": "Regency Centers",
        "arr": 57827
      }
    ],
    "newLogos": []
  },
  {
    "month": "2026-08",
    "arr": 12654122,
    "customers": 94,
    "newArr": 0,
    "expansionArr": 5535,
    "contractionArr": 0,
    "churnArr": 13502,
    "churnedLogos": 1,
    "churned": [
      {
        "name": "Enable-U / Gemeente Apeldoorn",
        "arr": 13502
      }
    ],
    "newLogos": []
  },
  {
    "month": "2026-09",
    "arr": 13446845,
    "customers": 94,
    "newArr": 100000,
    "expansionArr": 767938,
    "contractionArr": 0,
    "churnArr": 75215,
    "churnedLogos": 1,
    "churned": [
      {
        "name": "Tensoft",
        "arr": 75215
      }
    ],
    "newLogos": [
      "CSI Web"
    ]
  },
  {
    "month": "2026-10",
    "arr": 12805887,
    "customers": 91,
    "newArr": 0,
    "expansionArr": 1025,
    "contractionArr": 40,
    "churnArr": 641942,
    "churnedLogos": 3,
    "churned": [
      {
        "name": "Visa USA",
        "arr": 393750
      },
      {
        "name": "Evernorth",
        "arr": 180000
      },
      {
        "name": "Uzio",
        "arr": 68192
      }
    ],
    "newLogos": []
  }
];
/** Customers by ARR in the latest month (top 15 + count). */
export const RILLET_TOP_CUSTOMERS: { name: string; arr: number }[] = [
  {
    "name": "Voya Financial",
    "arr": 1436278
  },
  {
    "name": "Fidelity Technology Group, LLC",
    "arr": 1350000
  },
  {
    "name": "Standard Insurance Company",
    "arr": 1272201
  },
  {
    "name": "FIS",
    "arr": 749999
  },
  {
    "name": "AIG Global Operations, Inc.",
    "arr": 659592
  },
  {
    "name": "Hussmann Corporation",
    "arr": 465058
  },
  {
    "name": "Manulife",
    "arr": 462500
  },
  {
    "name": "Prudential",
    "arr": 419839
  },
  {
    "name": "Paradigm Management Services, LLC",
    "arr": 380115
  },
  {
    "name": "Orion Advisor Technology, LLC",
    "arr": 366667
  },
  {
    "name": "Cencora (Formerly AmerisourceBergen)",
    "arr": 350531
  },
  {
    "name": "Diodes, Incorporated",
    "arr": 344460
  },
  {
    "name": "Thomson Reuters Applications Inc",
    "arr": 340000
  },
  {
    "name": "FIL Investment Management Limited",
    "arr": 331523
  },
  {
    "name": "PAYCHEX, INC.",
    "arr": 275000
  }
];
export const RILLET_CUSTOMER_COUNT = 91;
/** In-effect contracts ending in the next 180 days (from the pull date). */
export const RILLET_RENEWALS: RilletRenewal[] = [
  {
    "customer": "Manulife",
    "contract": "2026 Software Amendment",
    "endDate": "2026-11-30",
    "value": 49313,
    "renewed": true
  },
  {
    "customer": "Manulife",
    "contract": "2025 Software Renewal",
    "endDate": "2026-11-30",
    "value": 344149,
    "renewed": true
  },
  {
    "customer": "Topco Associates, LLC",
    "contract": "2019-676",
    "endDate": "2026-11-30",
    "value": 428866,
    "renewed": true
  },
  {
    "customer": "Reinsurance Group of America (RGA)",
    "contract": "2025 Software Renewal",
    "endDate": "2026-12-02",
    "value": 54425,
    "renewed": false
  },
  {
    "customer": "Standard Insurance Company",
    "contract": "2026 Software Amendment",
    "endDate": "2026-12-04",
    "value": 37548,
    "renewed": true
  },
  {
    "customer": "Standard Insurance Company",
    "contract": "2023-932",
    "endDate": "2026-12-04",
    "value": 1050461,
    "renewed": true
  },
  {
    "customer": "UNUM",
    "contract": "2025 Software Renewal",
    "endDate": "2026-12-13",
    "value": 197676,
    "renewed": false
  },
  {
    "customer": "DTN, LLC",
    "contract": "2025 Software Renewal",
    "endDate": "2026-12-14",
    "value": 34786,
    "renewed": false
  },
  {
    "customer": "FIL Investment Management Limited",
    "contract": "2021-871",
    "endDate": "2026-12-30",
    "value": 1618006,
    "renewed": false
  },
  {
    "customer": "Primeur Suiesse Sa / FCA",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 11136,
    "renewed": false
  },
  {
    "customer": "Primeur Portel, Spain",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 14689,
    "renewed": false
  },
  {
    "customer": "PRIMEUR SUISSE SA",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 17542,
    "renewed": false
  },
  {
    "customer": "Primeur Suisse Sa / Corner Banca",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 11136,
    "renewed": true
  },
  {
    "customer": "Infosys Limited",
    "contract": "2026 Managed Services",
    "endDate": "2026-12-31",
    "value": 75600,
    "renewed": false
  },
  {
    "customer": "Enable-U / Solviteers",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 3230,
    "renewed": false
  },
  {
    "customer": "Enable-U / Provincie Zuid Holland",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 9837,
    "renewed": false
  },
  {
    "customer": "Enable-U / Gemeente Maastricht",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 7494,
    "renewed": false
  },
  {
    "customer": "Enable-U / 3F Department",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 2810,
    "renewed": false
  },
  {
    "customer": "Enable-U / Gemeente Oosterhoust - Equalit",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 20609,
    "renewed": false
  },
  {
    "customer": "Enable-U / MijnGemeenteDichtbij",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 2810,
    "renewed": false
  },
  {
    "customer": "Enable-U/Den Haag/City of Hague",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 4215,
    "renewed": false
  },
  {
    "customer": "Enable-U - Digikopeling Waterschap Noorderzijlvest",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 4496,
    "renewed": false
  },
  {
    "customer": "Enable-U / Gemeente Enschede Support",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 15082,
    "renewed": false
  },
  {
    "customer": "Enable-U / Peel in Maas",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 2810,
    "renewed": false
  },
  {
    "customer": "Enable-U / Gemeente Emmen",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 2810,
    "renewed": false
  },
  {
    "customer": "Enable-U / EPM Music Netherlands",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 6557,
    "renewed": false
  },
  {
    "customer": "Enable-U / Gemeente Zwolle support",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 12646,
    "renewed": false
  },
  {
    "customer": "Enable-U-Gemeente Groningen",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 51708,
    "renewed": false
  },
  {
    "customer": "Enable-U / Gemeente Helmond",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 2810,
    "renewed": false
  },
  {
    "customer": "Enable-U - Woningnet",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 3747,
    "renewed": false
  },
  {
    "customer": "Enable-U / Gemeente Haarlem",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 750,
    "renewed": false
  },
  {
    "customer": "Enable-U / TU Eindhoven",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 1124,
    "renewed": false
  },
  {
    "customer": "Enable-U / Waterschap Valei en Veluwe",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 1498,
    "renewed": false
  },
  {
    "customer": "Enable-U / Gemeente Lansingerland",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 2248,
    "renewed": false
  },
  {
    "customer": "Enable-U / Meerinzicht",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 2248,
    "renewed": false
  },
  {
    "customer": "Enable-U / Gemeente Zeist",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 2248,
    "renewed": false
  },
  {
    "customer": "E2open, LLC",
    "contract": "2026 Software Renewal",
    "endDate": "2026-12-31",
    "value": 65000,
    "renewed": false
  },
  {
    "customer": "AIG Global Operations, Inc.",
    "contract": "AIG Managed Services 2026",
    "endDate": "2026-12-31",
    "value": 284592,
    "renewed": false
  },
  {
    "customer": "Primeur Suisse SA / Sherpatech (Zust Ambrosetti)",
    "contract": "2025 Software License Renewal",
    "endDate": "2026-12-31",
    "value": 18478,
    "renewed": true
  },
  {
    "customer": "Enable-U/Gemeente Hengelo Support",
    "contract": "2019-587",
    "endDate": "2026-12-31",
    "value": 11325,
    "renewed": false
  },
  {
    "customer": "Enable-U / Royal Smilde Foods",
    "contract": "2019-554",
    "endDate": "2026-12-31",
    "value": 40703,
    "renewed": false
  },
  {
    "customer": "Insperity",
    "contract": "2026 Software Maintenance Renewal",
    "endDate": "2027-01-14",
    "value": 17400,
    "renewed": false
  },
  {
    "customer": "Sensaria",
    "contract": "2026 Software Renewal",
    "endDate": "2027-01-24",
    "value": 39569,
    "renewed": false
  },
  {
    "customer": "Benefit Communication Insourcing (BCI)",
    "contract": "2019-639",
    "endDate": "2027-02-14",
    "value": 124681,
    "renewed": false
  },
  {
    "customer": "Guardian Life Insurance Company",
    "contract": "2026 Software Renewal",
    "endDate": "2027-02-15",
    "value": 46800,
    "renewed": false
  },
  {
    "customer": "Enable-U / RID De Leimers",
    "contract": "2026 Software Renewal",
    "endDate": "2027-02-16",
    "value": 21134,
    "renewed": false
  },
  {
    "customer": "Maxex",
    "contract": "2026 Software License",
    "endDate": "2027-02-26",
    "value": 45000,
    "renewed": false
  },
  {
    "customer": "DoseSpot",
    "contract": "2025 Software Order",
    "endDate": "2027-03-05",
    "value": 30000,
    "renewed": false
  },
  {
    "customer": "Flores & Associates LLC",
    "contract": "2026 Software Renewal",
    "endDate": "2027-03-13",
    "value": 56000,
    "renewed": false
  },
  {
    "customer": "ARAG Legal Insurance",
    "contract": "2019-677",
    "endDate": "2027-03-25",
    "value": 166800,
    "renewed": false
  },
  {
    "customer": "Diodes, Incorporated",
    "contract": "2026 Managed Services",
    "endDate": "2027-03-31",
    "value": 163020,
    "renewed": false
  },
  {
    "customer": "Texon",
    "contract": "2026 Software Renewal",
    "endDate": "2027-03-31",
    "value": 46725,
    "renewed": false
  },
  {
    "customer": "Sewell Family of Companies, Inc.",
    "contract": "2026 Software License",
    "endDate": "2027-04-16",
    "value": 50000,
    "renewed": false
  }
];
